import { render, staticRenderFns } from "./share-record-recipient-info.vue?vue&type=template&id=1422d190&scoped=true&"
import script from "./share-record-recipient-info.vue?vue&type=script&lang=js&"
export * from "./share-record-recipient-info.vue?vue&type=script&lang=js&"
import style0 from "./share-record-recipient-info.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./share-record-recipient-info.vue?vue&type=style&index=1&id=1422d190&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1422d190",
  null
  
)

export default component.exports